<template>
    <v-lightbox :is-authenticated="isAuthenticated">
        <template v-slot:trigger>
            <div class="lg:hidden">
                <a
                    @click="show = true"
                    :class="[
                        'button',
                        searchSavedSuccessfuly
                            ? 'button--salmon'
                            : 'button--salmon-hover',
                    ]"
                >
                    <template v-if="searchSavedSuccessfuly">
                        <v-icon icon="heart-solid"></v-icon>
                        <label>Iskanje shranjeno</label>
                    </template>
                    <template v-else>
                        <v-icon icon="heart"></v-icon>
                        <label>Shranite iskanje</label>
                    </template>
                </a>
            </div>
            <div class="hidden lg:flex">
                <a
                    @click="show = true"
                    :class="[
                        'button group',
                        searchSavedSuccessfuly
                            ? 'button--salmon'
                            : 'button--salmon-hover',
                    ]"
                >
                    <template v-if="searchSavedSuccessfuly">
                        <v-icon icon="heart-solid"></v-icon>
                        <label>Iskanje shranjeno</label>
                    </template>
                    <template v-else>
                        <v-icon
                            icon="heart"
                            class="group-hover:hidden"
                        ></v-icon>
                        <v-icon
                            icon="heart-solid"
                            class="hidden group-hover:flex"
                        ></v-icon>
                        <label>Shranite iskanje</label>
                    </template>
                </a>
            </div>
        </template>
        <template v-slot:head>
            <v-icon icon="heart-solid" class="mr-2.5 text-salmon"></v-icon>
            Shranite iskanje
        </template>
        <template v-slot:content>
            <template v-if="isAuthenticated && !searchSavedSuccessfuly">
                <figure
                    class="mx-auto mb-7 flex max-w-[440px] items-center gap-4 lg:w-[414px]"
                >
                    <div
                        class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-green"
                    >
                        <v-icon
                            icon="loupe-again"
                            size="5"
                            class="text-white"
                        ></v-icon>
                    </div>
                    <div class="text-icon-text-medium">
                        Enostavna ponovna iskanja
                    </div>
                </figure>
                <figure
                    class="mx-auto flex max-w-[440px] items-center gap-4 lg:w-[414px]"
                >
                    <div
                        class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-green"
                    >
                        <v-icon
                            icon="dong"
                            size="5"
                            class="text-white"
                        ></v-icon>
                    </div>
                    <div class="text-icon-text-medium">
                        Bodite obveščeni o novih oglasih
                    </div>
                </figure>
                <div class="mb-8 mt-8 h-[1px] w-full bg-gray-border"></div>
                <div>
                    <div class="flex flex-col items-center">
                        <div
                            class="mb-7 mt-10 text-center text-icon-text-medium"
                        >
                            Iskanje, katerega boste shranili:
                        </div>
                        <div class="grid grid-cols-2 grid-rows-2 gap-2 lg:mb-9">
                            <a
                                class="flex cursor-default items-center justify-start gap-2 rounded-full bg-green-10 px-6 py-3 text-small-text-medium"
                            >
                                <v-icon icon="map-pin"></v-icon>
                                {{ location ? location : region}}
                            </a>
                            <a
                                class="flex cursor-default items-center justify-start gap-2 rounded-full bg-green-10 px-6 py-3 text-small-text-medium"
                            >
                                <v-icon icon="buy-house"></v-icon>
                                {{ rentOrBuy }}
                            </a>
                            <a
                                class="flex cursor-default items-center justify-start gap-2 rounded-full bg-green-10 px-6 py-3 text-small-text-medium"
                            >
                                <v-icon icon="apartment"></v-icon>
                                {{ propertyType }}
                            </a>
                            <a
                                class="flex cursor-default items-center justify-start gap-2 rounded-full bg-green-10 px-6 py-3 text-small-text-medium"
                            >
                                <v-icon icon="euro"></v-icon>
                                {{ priceFrom }} - {{ priceTo }} €
                            </a>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="searchSavedSuccessfuly">
                <div class="mb-5 flex flex-col items-center">
                    <div
                        class="mt-5 flex items-center text-icon-text-medium text-green"
                    >
                        <v-icon icon="check-circle" class="mr-2"></v-icon>
                        Uspešno ste shranili iskanje
                    </div>
                    <div
                        class="mb-12 mt-12 h-[1px] w-full bg-gray-border"
                    ></div>
                    <figure
                        class="mx-auto mb-7 flex max-w-[440px] items-center gap-4"
                    >
                        <div
                            class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="loupe-again"
                                size="5"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-regular">
                            Shranjena iskanja so vam na voljo na domači strani
                            za hitrejše iskanje.
                        </div>
                    </figure>
                    <figure
                        class="mx-auto flex max-w-[440px] items-center gap-4"
                    >
                        <div
                            class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="dong"
                                size="5"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-regular">
                            Prav tako boste po e-pošti obveščeni o novih
                            oglasih, ki ustrezajo vašim shranjenim iskanjem.
                        </div>
                    </figure>
                </div>
            </template>
        </template>
        <template v-slot:foot>
            <a
                v-if="isAuthenticated && !searchSavedSuccessfuly"
                :class="[
                    'button',
                    saving ? 'button button--gray cursor-not-allowed' : '',
                ]"
                @click="saveSearch()"
            >
                <v-icon icon="heart"></v-icon>
                Shranite iskanje
            </a>
            <a
                v-if="searchSavedSuccessfuly"
                class="button"
                :href="searchListRoute"
            >
                <v-icon icon="heart"></v-icon>
                Oglejte si vsa shranjena iskanja
            </a>
        </template>
    </v-lightbox>
</template>

<script>
export default {
    props: {
        searchSaveRoute: {
            type: String,
            required: true,
        },
        searchListRoute: {
            type: String,
            required: true,
        },
        registerRoute: {
            type: String,
            required: true,
        },
        searchParams: {
            type: Object,
            required: true,
        },
        isAuthenticated: {
            type: Boolean,
            required: true,
        },
        country: {
            type: String,
            default: null,
        },
        region: {
            type: String,
            default: null,
        },
        location: {
            type: String,
            default: null,
        },
        rentOrBuy: {
            type: String,
            default: null,
        },
        propertyType: {
            type: String,
            default: null,
        },
        priceFrom: {
            type: [String, Number],
            default: null,
        },
        priceTo: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            searchSavedSuccessfuly: false,
            saving: false,
        };
    },
    mounted() {},
    methods: {
        saveSearch() {
            if (this.saving) {
                return;
            }

            this.saving = true;
            let data = {
                real_estate_location: this.searchParams.location,
                real_estate_type: this.searchParams.realestate_property_type,
                rent_or_buy: this.searchParams.rent_or_buy,
                real_estate_price_from: this.searchParams.price_from ?? 0,
                real_estate_price_to: this.searchParams.price_to ?? 0,
                real_estate_country: this.country,
                real_estate_region: this.region,
                search_radius: 5//this.radius,
            };

            axios
                .post(this.searchSaveRoute, data, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.searchSavedSuccessfuly = true;
                        this.saving = false;
                    },
                    (error) => {
                        console.log(error);
                        this.saving = false;
                    }
                );
        },
    },
};
</script>
